<template>
  <div>
    <div class="about">
      <div class="header-image" :style="'background-image:url(' + featuredImage + ');'" v-if="featuredImage">
        <SubTopNav v-if="title" :title="title" />
      </div>
      <div v-else :class="'header-image default-header-' + rand">
        <SubTopNav v-if="title" :title="title" />
      </div>

      <div class="page-content">
        <div class="page-grid">
          <div class="content-body item animated fadeInUp" v-for="(item, index) in contentBody" :key="index">
            <div class="body-row">
              <!-- {{ contentImages[index] }} -->

              <div v-if="index == 0">
                <h3>{{ tagline }}</h3>
                <div v-html="item.value"></div>
              </div>
              <div v-else v-html="item.value"></div>
              <div class="body-image" v-if="contentImages && contentImages[index]">
                <img :src="contentImages[index].url" v-if="contentImages[index].url" />
                --
              </div>
            </div>
          </div>
        </div>

        <h3 class="page-subheader animated fadeInUp" v-show="group && group.length > 0">Opportunities</h3>
        <div class="item-group">
          <!-- {{ group }} -->

          <div v-for="item in group" :key="item.nid" class="group-item" @click="getItem(item.alias)">
            <div class="img" v-if="item && item.field_content_image_s_"><img :src="baseDomain + item.field_content_image_s_" v-if="item.field_content_image_s_" /></div>
            <div class="name">
              <h3 v-html="item.title"></h3>
            </div>
          </div>
        </div>

        <!-- Ease of Doing Business Reforms -->

        <h3 class="animated fadeInUp">{{ easeTitle }}</h3>
        <div class="content-body item animated fadeInUp" v-for="(item, index) in easeBody" :key="index">
          <div class="body-row">
            <!-- {{ contentImages[index] }} -->

            <div v-if="index == 0">
              <div v-html="item.value"></div>
            </div>
            <div v-else v-html="item.value"></div>
          </div>
        </div>
        <b-button-group class="reform-button">
          <b-button :variant="showRecommendation == reform.nid ? 'success' : ''" v-for="reform in reforms" :key="reform.nid" @click="getReformRecommendations(reform.nid)">{{ reform.title }} &raquo;</b-button>
        </b-button-group>

        <div class="recommendations">
          <div v-for="reform in reforms" :key="reform.nid" v-show="showRecommendation == reform.nid" class="reform-header">
            <h3>{{ reform.title }}</h3>
            <div v-html="reform.body"></div>
          </div>
          <div v-for="recommendation in recommendations" :key="recommendation.nid" v-show="recommendation.field_reformarea == showRecommendation" class="recommendation">
            <h5>{{ recommendation.title }}</h5>
            <div :class="['status', recommendation.field_status == 'In Progress' ? 'status-progress' : '', recommendation.field_status == 'Completed' ? 'completed' : '', recommendation.field_status == 'Not Started' ? 'not-started' : '']">{{ recommendation.field_status }}</div>
          </div>
        </div>
        <div v-if="total && total > 0" class="total-grid">
          <div>Not Started:</div>
          <div>{{ notStarted }}</div>
          <div>In Progress:</div>
          <div>{{ inProgress }}</div>
          <div>Completed:</div>
          <div>{{ completed }}</div>
          <div>Total:</div>
          <div>{{ total }}</div>
        </div>
        <!-- <div>{{ recommendations }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from "vuex"
import SubTopNav from "@/components/SubTopNav.vue"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "about",
  components: {
    SubTopNav,
  },
  data: function() {
    return {
      content: null,
      image: null,
      featuredImage: null,
      contentImages: [],
      group: [],
      contentBody: null,
      title: null,
      rand: 1,
      tagline: null,
      siblings: [],
      reforms: [],
      recommendations: [],
      easeTitle: null,
      easeTagline: null,
      easeBody: null,
      showRecommendation: null,
      total: 0,
      inProgress: 0,
      completed: 0,
      notStarted: 0,
    }
  },
  methods: {
    async getNode(id) {
      // var id = "2"
      const { data } = await ContentRepository.getNode(id)
      // console.log('home page data', data)

      this.title = data.title[0].value
      this.tagline = data.body[0].summary
      this.featuredImage = data.field_feature_image && data.field_feature_image[0] && data.field_feature_image[0].url ? data.field_feature_image[0].url : null
      this.contentImages = data.field_content_image_s_
      this.contentBody = data.body

      // this.getSiblings()
    },
    async getGroup(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.group = data.reverse()
      // console.log('group', data)

      // this.getSiblings()
    },
    getItem(alias) {
      var aliasName = alias.split("/").pop()
      var path = "/sector/" + aliasName

      this.$router.push(path)
    },

    async getEaseOverview(id) {
      const { data } = await ContentRepository.getNode(id)
      // console.log('home page data', data)

      this.easeTitle = data.title[0].value
      this.easeTagline = data.body[0].summary
      this.easeBody = data.body
    },

    async getReforms(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.reforms = data.reverse()
      // console.log('group', data)

      // this.getSiblings()
    },

    async getRecommendations(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.recommendations = data
      // console.log('group', data)

      // this.getSiblings()
    },

    getReformRecommendations(nid) {
      this.showRecommendation = nid

      var subRecommendations = this.recommendations.filter((item) => {
        return item.field_reformarea == nid
      })

      this.total = subRecommendations.length

      var inProgress = subRecommendations.filter((item) => {
        return item.field_status == "In Progress"
      })

      this.inProgress = inProgress.length

      var notStarted = subRecommendations.filter((item) => {
        return item.field_status == "Not Started"
      })

      this.notStarted = notStarted.length

      var completed = subRecommendations.filter((item) => {
        return item.field_status == "Completed"
      })

      this.completed = completed.length
    },
    // getSiblings(){
    // 	var navigation = this.$session.get('navigation')
    // 	var pageTitle = this.title.toLowerCase()
    // 	if (navigation && navigation.length){
    // 		var menuItemArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == pageTitle
    //       })

    //       var menuItem = menuItemArr[0]
    //       var menuParent = menuItem.parent

    //       if (menuParent){
    //       	var siblingsArr = navigation.filter(function (item){
    //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
    //       	})

    //       	this.siblings = siblingsArr

    //       }

    //       // console.log('sub expertise', this.subExpertise)
    // 	}
    // }
  },
  computed: {
    ...mapState(["baseDomain"]),
  },
  mounted() {
    var api = this.$route.meta.api
    if (api && api.length && api.length > 0) {
      api.forEach((item) => {
        if (item.type == "node") {
          this.getNode(item.id)
        }
        if (item.type == "group") {
          this.getGroup(item.id)
        }
      })
      // if (api.type == "node"){
      // 	this.getNode(api.id)
      // } else if (api.type == "group") {
      // 	this.getGroup(api.id)
      // } else {

      // }
    }

    this.getEaseOverview(87)
    this.getReforms("reform_area")
    this.getRecommendations("recommendation")

    // {type: 'node', id: '87' },
    //        {type: 'group', id: 'reform_area' },
    //        {type: 'group', id: 'recommendation' },

    this.rand = Math.floor(Math.random() * 8) + 1
  },
}
</script>
<style scoped>
.page-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
}

.about {
  overflow-x: hidden;
}

.page-grid .item {
  xbackground: #ccc;
  xpadding: 10px;
}

.page-grid .item:nth-child(1) {
  xborder: 1px solid red;
  grid-column: 1 / 3;
}

.page-grid .item:nth-child(1) .body-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #f7f1eb;
  xborder: 10px solid #e1e1e1;
  xpadding: 25px;
  grid-gap: 25px;
  margin-top: 25px;
  xborder-radius: 0px 0px 85px 0px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(1) {
  padding: 25px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3 {
  margin-top: 55px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) {
  xpadding: 25px;
}

.page-grid img {
  width: 100%;
}

.page-grid .item:nth-child(2) {
  border-top: 5px solid #cc0000;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(3) {
  border-top: 5px solid #663300;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(4) {
  xborder-top: 5px solid #339900;
  color: #fff;
  background: #339900;
  font-size: 120%;
  padding: 20px 320px;
  margin-left: -300px;
  margin-right: -300px;
  margin-top: 20px;
  grid-column: 1 / 3;
}

.page-content {
  text-align: left;
  xmargin-bottom: 30px;
}

.image-break {
  height: 300px;
  xbackground: #ccc;
  margin-top: 35px;
  margin-bottom: 35px;
}

.image-box {
  height: 300px;
  top: 0;
  left: 0;
  filter: grayscale(100%);
  xopacity: 0.3;
}

.image-text {
  margin-top: -300px;
  z-index: 50;
  position: relative;
}

.image-text a {
  color: #fff;
}

.image-text .container div {
  background: rgba(255, 102, 0, 0.8);
  color: #fff;
  padding: 105px 50px 50px 50px;
  float: left;
  width: 50%;
  height: 300px;
}

.page-content .content-body:nth-child(2n) .image-text .container div {
  float: right;
  background: rgba(102, 153, 51, 0.8);
}

.item-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 25px;
}

.recommendations {
  margin-top: 40px;
}

.group-item {
  xpadding: 25px;
  box-shadow: 3px 3px 5px #ccc;
  background-size: 25px;
  cursor: pointer;
  border-radius: 0 0 25px 0;
  margin-bottom: 40px;
}

.group-item .name {
  padding: 25px;
}

.page-subheader {
  margin-top: 40px;
}

.group-item img {
  width: 100%;
}

:deep(.inline-image) {
  max-width: 100%;
  border: 1px solid red !important;
}

.group-item .img {
  height: 250px;
  overflow: hidden;
}

.body-row {
  xpadding: 25px;
}

.recommendations {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  margin-bottom: 25px;
}

.reform-header {
  color: #00733c;
}

.recommendations div.reform-header {
  grid-column: 1/4;
}

.recommendation {
  box-shadow: 3px 3px 5px #ccc;
  border-radius: 0 0 25px 0;
  padding: 25px;
}

.recommendation h5 {
  min-height: 130px;
}

.total-grid {
  display: grid;
  grid-template-columns: 130px 1fr;
  font-weight: bold;
  margin-bottom: 35px;
}

.status {
  display: inline-block;
  border-radius: 5px;
  padding: 5px 10px;
  background: #000;
  color: #fff;
  font-weight: bold;
  font-size: 90%;
}

.status-progress {
  background: #ff9900;
}

.completed {
  background: green;
}

.not-started {
  background: #cc0000;
}

@media (max-width: 768px) {
  .recommendations {
    display: block;
  }

  .reform-button {
    display: block !important;
    border-radius: 0;
  }

  .reform-button .btn {
    display: block;
    width: 100%;
    border-radius: 5px !important;
  }
}
</style>
